/**
 * ?????? ????API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js????????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ?????? API
 * ================================================================ */

/**
 * ?????? ?? ???? (??????????+ ?????????).
 *
 * @param {Object} params - { keyword, viewYn, page, size }
 * @returns {Promise} { data: { items, total, page, size, totalPages }, code, message }
 */
export function getCategoryList(params) {
  return api.get('/api/v1/category', { params })
}

/**
 * ?????? ????? ????.
 *
 * @param {string} categoryCode - ???????????
 * @returns {Promise} { categoryCode, categoryName, viewYn, ... }
 */
export function getCategoryDetail(categoryCode) {
  return api.get(`/api/v1/category/${categoryCode}`)
}

/**
 * ?????? ??? (HQ ?????? ?????).
 *
 * @param {Object} data - { categoryName, viewYn }
 * @returns {Promise} ??????????? ????? ?????
 */
export function createCategory(data) {
  return api.post('/api/v1/category', data)
}

/**
 * ?????? ??? ???? (HQ ?????? ?????).
 *
 * @param {string} categoryCode - ?????????????????
 * @param {Object} data - { categoryName, viewYn }
 * @returns {Promise} ???????????? ????? ?????
 */
export function updateCategory(categoryCode, data) {
  return api.put(`/api/v1/category/${categoryCode}`, data)
}

/**
 * ?????? ???????? ???? (HQ ?????? ?????).
 * view_yn 'Y' ??'N' ????? 'N' ??'Y' ??????? ?????????.
 *
 * @param {string} categoryCode - ?????????????????
 * @returns {Promise} ????? ?????? ????? ?????
 */
export function toggleCategoryView(categoryCode) {
  return api.post(`/api/v1/category/${categoryCode}/view`)
}

/**
 * ?????? ???? (HQ ?????? ?????, soft delete).
 * ?????????? ??????????????code=6001(CATEGORY_HAS_PRODUCTS) ????????????????.
 *
 * @param {string} categoryCode - ?????????????????
 * @returns {Promise} { code, message }
 */
export function deleteCategory(categoryCode) {
  return api.delete(`/api/v1/category/${categoryCode}`)
}
